import { render } from "./TeamOptionInput.vue?vue&type=template&id=4788d4db&scoped=true&ts=true"
import script from "./TeamOptionInput.vue?vue&type=script&lang=ts"
export * from "./TeamOptionInput.vue?vue&type=script&lang=ts"

import "./TeamOptionInput.vue?vue&type=style&index=0&id=4788d4db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4788d4db"]])

export default __exports__